module.exports = __webpack_public_path__ + "static/img/1.4588f66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-salud/1.png
// module id = 1cKh
// module chunks = 0